export default function Track(event) {
    if (typeof window !== 'undefined' && window.emAna) {window.emAna('track', 'Branding-' + event); }
}

// we append Branding- to the start of each tag
